module.exports = require('./helpers/bundle-url').getBundleURL('ksUvU') + "outstation_icon.25b869a6.png" + "?" + Date.now();